import { render } from "./SubscriptionDetails.vue?vue&type=template&id=98205ece&scoped=true&ts=true"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=ts"

import "./SubscriptionDetails.vue?vue&type=style&index=0&id=98205ece&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98205ece"]])

export default __exports__